module.exports = __webpack_public_path__ + "static/media/chrome.b5bfb7ac.png";